import { z } from "zod"

import { documentSchema } from "./document"

// Definition of the TariffDocument schema
export const tariffDocumentSchema = z.object({
  /** The tariff ID associated with this document */
  tariffId: z.number().int(),
  /** Unique ID of the document associated with this tariff */
  documentId: z.number().int(),
  /** Unique ID of the section of the document associated with this tariff */
  documentSectionId: z.number().int(),
  /** The Document object associated with this tariff */
  document: documentSchema,
})

export type TariffDocument = z.infer<typeof tariffDocumentSchema>
